export const WA_PHONE = import.meta.env.VITE_WA_PHONE || '972524106717';
export const WA_URL = `https://wa.me/${WA_PHONE}`;
export const WA_DISPLAY = '052-410-6717';
export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://focusmode.info';
export const GA4_ID = import.meta.env.VITE_GA4_ID;
export const PIXEL_ID = import.meta.env.VITE_PIXEL_ID;

export const TIKTOK_PIXEL_ID = import.meta.env.VITE_TIKTOK_PIXEL_ID;
